import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Store from "./App/Store"; // Import your Redux store here
import { InputFieldProvider } from "./pages/AI_Copilot/InputFieldContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={Store}>
      <InputFieldProvider>
        <App />
      </InputFieldProvider>
    </Provider>
  </BrowserRouter>
);


reportWebVitals();
